import { render, staticRenderFns } from "./NewPaymentsPayoneerHead.vue?vue&type=template&id=38e36efb&scoped=true"
import script from "./NewPaymentsPayoneerHead.vue?vue&type=script&lang=js"
export * from "./NewPaymentsPayoneerHead.vue?vue&type=script&lang=js"
import style0 from "./NewPaymentsPayoneerHead.vue?vue&type=style&index=0&id=38e36efb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e36efb",
  null
  
)

export default component.exports